<template>
  <div class="row no-gutters d-flex">
    <div class="col-12 mx-auto d-flex">
      <div class="col-6 flex-column d-flex">
        <div class="d-flex flex-column align-self-center" style="width:550px">
          <div class="d-flex">
            <div>
              <select class="custom-select">
                <option selected>分類一</option>
              </select>
            </div>
            <div>
              <select class="custom-select">
                <option selected>分類一</option>
              </select>
            </div>
          </div>
          <div class="d-flex align-content-center">
            <div class="d-flex flex-fill">
              <select class="custom-select">
                <option selected>分類一</option>
              </select>
            </div>
            <div class="d-flex flex-fill">
              <b-form-input></b-form-input>
            </div>
            <div class="ml-3 d-flex flex-column flex-fill text-left">
              <b-form-radio name="uploadRadio" value="A">所有分類</b-form-radio>
              <b-form-radio name="uploadRadio" value="B">僅於此分類內</b-form-radio>
            </div>
            <div class="d-flex flex-fill">
              <button type="button" class="btn btn-primary">查詢</button>
            </div>
          </div>
        </div>
        <div class="d-flex flex-fill align-self-center">共1筆</div>
        <table class="table table-bordered">
      <thead>
        <tr>
          <th scope="col">
            排序
          </th>
          <th scope="col">
            商品
          </th>
          <th scope="col">
            選擇
          </th>
        </tr>
      </thead>
      <tbody>

      </tbody>
    </table>
      </div>
      <div class="col-6">
        <div class="row no-gutters">
          <div class="col-12 d-flex">
            <ul class="nav nav-tabs flex-fill">
              <li class="nav-item">
                <a @click="drag = true" href="#" class="nav-link">拖曳圖片上傳</a>
              </li>
              <li class="nav-item">
                <a @click="drag = false" href="#" class="nav-link">選擇圖片上傳</a>
              </li>
            </ul>
          </div>
          <div v-if="drag" class="col-12 d-flex flex-column text-left">
            <div class="d-flex justify-content-around">
              <h3>1.先於左側點某商品的 傳圖</h3>
              <h3>2.再將圖片拖曳進來，便完成上傳</h3>
            </div>
            <b-form-file v-model="file" :multiple="true" placeholder="拖曳圖片到此處上傳"
              drop-placeholder="拖曳圖片到此處上傳"></b-form-file>
            <div class="d-flex">
              <b-form-checkbox value="accepted" unchecked-value="not_accepted">
                加入浮水印
              </b-form-checkbox>
              <a href="#" v-b-modal="'setstyle'">設定樣式</a>
            </div>
          </div>
          <div v-else class="col-12 d-flex">
            <b-form-file v-model="file" :multiple="true" placeholder="拖曳圖片到此處上傳"
              drop-placeholder="拖曳圖片到此處上傳"></b-form-file>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="setstyle" title="勾選要使用的浮水印樣式">
      <div class="d-flex flex-column">
        <b-form-checkbox value="accepted" unchecked-value="not_accepted">
          置中大的浮水印
        </b-form-checkbox>
        <div class="row no-gutters d-flex flex-fill justify-content-around">
          <div class="col-2">
            <label for="input-default">浮水印文字</label>
          </div>
          <div class="col-10">
            <b-form-input v-model="floattext" id="input-default"></b-form-input>
          </div>
        </div>
        <div class="d-flex">
          <div>文字顏色</div>
          <div>
            <b-form-radio name="fontColorRadio" value="A">白色</b-form-radio>
          </div>
          <div>
            <b-form-radio name="fontColorRadio" value="B">黑色</b-form-radio>
          </div>
        </div>
        <div class="d-flex">
          <div>文字透明度</div>
          <div>
            <b-form-radio name="transparencyRadio" value="A">不透明</b-form-radio>
          </div>
          <div>
            <b-form-radio name="transparencyRadio" value="B">中透明</b-form-radio>
          </div>
          <div>
            <b-form-radio name="transparencyRadio" value="B">很透明（建議）</b-form-radio>
          </div>
        </div>
        <div class="d-flex">
          <div>文字大小</div>
          <div>
            <b-form-radio name="fontSizeRadio" value="A">80pt(大)</b-form-radio>
          </div>
          <div>
            <b-form-radio name="fontSizeRadio" value="B">55pt(中)</b-form-radio>
          </div>
          <div>
            <b-form-radio name="fontSizeRadio" value="B">30pt(小)</b-form-radio>
          </div>
        </div>
        <div class="d-flex">
          <img src="" alt="浮水印圖片sample">
        </div>
        <div>
          <hr>
        </div>
        <div>
          <b-form-checkbox value="accepted" unchecked-value="not_accepted">
          底部小的浮水印
        </b-form-checkbox>
        </div>
       <div class="row no-gutters d-flex flex-fill justify-content-around">
          <div class="col-2">
            <label for="input-default">浮水印文字</label>
          </div>
          <div class="col-10">
            <b-form-input v-model="floattext" id="input-default"></b-form-input>
          </div>
        </div>
        <div class="d-flex">
          <div>文字顏色</div>
          <div>
            <b-form-radio name="fontColorRadio2" value="white">白色</b-form-radio>
          </div>
          <div>
            <b-form-radio name="fontColorRadio2" value="black">黑色</b-form-radio>
          </div>
        </div>
        <div class="d-flex">
          <img src="" alt="浮水印圖片sample">
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
// import MultipleFileUploader from '@updivision/vue2-multi-uploader';

export default {
  data() {
    return {
      drag: true,
      file: [],
      floattext: 'www.shop2000.com.tw/mac',
    };
  },
  components: {
    // MultipleFileUploader,
  },
};

</script>

<style lang="scss">
  .uploadol {
    display: inline;
  }

</style>
